import React, { useEffect, useState } from "react";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import { CHANGED_INVENTORIES_API } from "../../../../../../Utilities/APIs/APIs";
import { Form } from "react-router-dom";
import ShortTextInput from "../../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import DateInput from "../../../../../Partials/Layouts/Forms/FormInputs/DateInput/DateInput";
import SelectInput from "../../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";
import FormSubmitButton from "../../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";

function UpdateChangedInventories({ targetID, triggerFetch, setShowUpdateForm }) {
  const axiosInstance = useAxiosInstance();

  const [quantity, setQuantity] = useState("");
  const [date, setDate] = useState("");
  const [changeType, setChangeType] = useState("");

  // NEW: allow editing location for single-row entries
  const [productLocation, setProductLocation] = useState("");

  useEffect(() => {
    async function fetchAndSetSingleProductSize() {
      const { data } = await axiosInstance.get(
        CHANGED_INVENTORIES_API + "getSingleChangeInventory/" + targetID
      );
      setQuantity(data?.quantity);
      const dt = new Date(data.date);
      setDate(`${dt.toISOString().slice(0, 10)}`);
      setChangeType(data?.changeType);
      setProductLocation(data?.productLocation || "");
    }
    fetchAndSetSingleProductSize();
  }, [targetID, axiosInstance]);

  async function handleSubmit(e) {
    e.preventDefault();

    const payload =
      changeType === "newStock"
        ? {
            quantity: Number(quantity) || 0,
            date,
            changeType,
            productLocation: productLocation || null,
          }
        : {
            quantity: Number(quantity) || 0,
            date,
            changeType,
          };

    const response = await axiosInstance.patch(
      CHANGED_INVENTORIES_API + targetID,
      payload
    );
    if (response) {
      triggerFetch();
      setShowUpdateForm(false);
    }
  }

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div className="form-section">
          <DateInput label={"Date"} value={date} setState={setDate} />

          <SelectInput
            label={"Change Type"}
            value={changeType}
            setState={setChangeType}
          >
            <SelectOption optionValue="" optionText="Select Change Type" />
            <SelectOption optionValue="sold" optionText="sold" />
            <SelectOption optionValue="return" optionText="return" />
            <SelectOption optionValue="newStock" optionText="newStock" />
          </SelectInput>

          <ShortTextInput
            label={`Quantity`}
            value={quantity}
            placeholder={`Enter Quantity`}
            setState={setQuantity}
          />

          {changeType === "newStock" && (
            <SelectInput
              label={"Location"}
              value={productLocation}
              setState={setProductLocation}
            >
              <SelectOption optionValue="" optionText="(Optional) Select Location" />
              <SelectOption optionValue="mainOffice" optionText="Main Office" />
              <SelectOption optionValue="showRoom" optionText="Showroom" />
              <SelectOption optionValue="wareHouse" optionText="Warehouse" />
            </SelectInput>
          )}
        </div>

        <FormSubmitButton text="Update Changed Inventories" />
      </Form>
    </div>
  );
}

export default UpdateChangedInventories;
